<script>
import { daysInWeek } from '@utils/filter-value-to-text'
import { messageStore, messageDelete } from '@utils/message'


const dateForm = () => {
  return {
    type: 'exclude',
    name: '',
    state: 1,
    rangeType: 'date',
    range: [],
    startDate: '',
    endDate: '',
    times: [
      {
        startTime: '00:00',
        endTime: '23:59',
      },
    ],
    timeRanges: [['00:00', '23:59']],
  }
}

export default {
  components: {},
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      usageRules: {},
      // timeRanges: [['', '']],
      usageRuleIndex: null,
      count: 0,
      daysInWeek,
      isCreated: false,
      filterDateRanges: [],
      activeNames: "",
    }
  },
  computed: {
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    formRules() {
      return {
        name: [
          {
            required: true,
            message: '請輸入限制名稱',
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: true,
            message: '請輸入日期',
            trigger: 'blur',
          },
        ],
        range: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                return callback(new Error('請選擇日期'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  created() {
    this.getDefaultDateRanges()
    if (!this.defaultValue.usageRules) {
      this.isCreated = true
    }
  },
  methods: {
    addTimeRange(index) {
      if(index === 'new') {
        this.usageRules.timeRanges.push(['00:00', '23:59'])
      } else {
        this.submitData.usageRules[index].timeRanges.push(['00:00', '23:59'])
      }
    },
    deleteTimeRange(index, timeRangesIndex) {
      if(index === 'new') {
        this.usageRules.timeRanges.splice(index, 1)
      } else {
        this.submitData.usageRules[index].timeRanges.splice(timeRangesIndex, 1)
      }
    },
    getDefaultDateRanges() {
      this.filterDateRanges = this.submitData.usageRules.map((item) => [item.startDate || '', item.endDate || ''])
    },
    creatUsageRule() {
      if (!this.isCreated) {
        this.usageRules = dateForm()
        this.submitData.usageRules.unshift(this.usageRules)
        this.getDefaultDateRanges()
        this.usageRuleIndex = null
        this.isCreated = true
      }
    },
    async saveSingleUsageRule(index) {
      try {
        let valid = true;
          await this.$refs[`form${index}`][0].validate((e)=> {
            if(!e) {
              valid = e
            }
          })
        if(!valid) {
          return false
        }
        const list = []
        this.usageRules.timeRanges.forEach((item) => {
          const [start, end] = item
          list.push({
            startTime: start,
            endTime: end,
          })
        })

        this.usageRules.times = list
        await this.$store.dispatch('prepaid/storeGroup', this.submitData)
        messageStore('edit')
        this.isCreated = false
      } catch {
      } finally {
        this.tryingStore = false
      }
    },
    async deleteSingleUsageRule(index) {
      await this.$confirm('確定要刪除此限制嗎？', '提醒', {
        confirmButtonText: '確定',
        // showCancelButton: false,
        type: 'warning',
        center: true,
      })
      this.submitData.usageRules.splice(index, 1)
      this.getDefaultDateRanges()
      await this.$store.dispatch('prepaid/storeGroup', this.submitData)
      messageDelete()
    },
    
    cancelUsageRle() {
      this.submitData.usageRules.splice(0, 1)
      this.getDefaultDateRanges()
      this.isCreated = false
    },
    getStartAndEndDate(value, index) {
      this.submitData.usageRules[index].startDate = value[0]
      this.submitData.usageRules[index].endDate = value[1]
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent">
      <div class="inline-between mb-3" style="align-items: center">
        <h4 class="form-block-title">時段限制</h4>
        <el-button class="is-round" type="primary" @click="creatUsageRule"><BaseIcon name="plus" /> 新增限制時段</el-button>
      </div>
      <el-row v-if="submitData.usageRules.length" :gutter="20">
        <el-col :span="24">
          <div v-for="(usageRule, index) in submitData.usageRules" :key="index">
            <div :class="$style.box" style="margin-bottom: 30px;">
              <el-form
                v-if="isCreated && index === 0"
                :ref="`form${index}`"
                class="el-form-item--white-bg"
                :validate-on-rule-change="true"
                style="padding:20px"
                :rules="formRules"
                :model="usageRule"
                label-position="top"
              >
                <span slot="title">{{ usageRule.name }}</span>
                <div :class="$style.switch">
                  是否關閉限制
                  <el-form-item prop="state">
                    <el-switch v-model="usageRule.state" active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0" @click.stop.native></el-switch>
                  </el-form-item>
                </div>
                <el-form-item label="限制名稱" prop="name">
                  <el-input v-model="usageRule.name"> </el-input>
                </el-form-item>
                <el-form-item label="時段類別">
                  <el-select v-model="usageRule.rangeType">
                    <el-option label="日期" :value="`date`"></el-option>
                    <el-option label="星期" :value="`week`"></el-option>
                  </el-select>
                </el-form-item>

                <template v-if="usageRule.rangeType">
                  <el-form-item v-if="usageRule.rangeType === 'week'" prop="range" label="重複於">
                    <el-checkbox-group v-model="usageRule.range" :class="$style.repeat">
                      <el-checkbox-button v-for="(weekDay, i) in daysInWeek" :key="i" :label="String(i)">{{ weekDay }}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item v-if="usageRule.rangeType === 'date'" prop="startDate" label="日期">
                    <el-date-picker
                      v-model="filterDateRanges[index]"
                      type="daterange"
                      align="left"
                      unlink-panels
                      range-separator="-"
                      value-format="yyyy-MM-dd"
                      start-placeholder="起始日期"
                      end-placeholder="結束日期"
                      style="width: 100%"
                      :clearable="false"
                      @change="getStartAndEndDate($event, index)"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item  v-for="(item, index2) in usageRule.timeRanges" :key="index2"   :prop="`timeRanges[${index2}][0]`"
                    :rules="{ required: true, message: '請輸入時間', trigger: 'blur' }"
                    style="margin-bottom: 30px">
                    <div class="inline-section">
                      <el-time-picker v-model="usageRule.timeRanges[index2]" 
                        :clearable="false" range-separator="至" format="HH:mm" value-format="HH:mm" placeholder="選擇時間" is-range

                      ></el-time-picker>
                      <el-button class="is-round is-no-border" :disabled="usageRule.timeRanges.length === 1" type="text" plain @click="deleteTimeRange('new', index2)">
                        <BaseIcon name="trash-alt" />
                      </el-button>
                    </div>
                  </el-form-item>
                  <el-button class="is-round is-fullwidth" style="margin-bottom: 40px" @click="addTimeRange('new')"><BaseIcon name="plus" /> 新增暫停使用時間</el-button>
                  <div class="btn-group-inline mt-4">
                    <el-button v-if="isCreated && index === 0 && defaultValue.usageRules" class="is-round" @click="cancelUsageRle"> 取消</el-button>
                    <el-button v-if="defaultValue.usageRules && !(isCreated && index === 0)" class="is-round" @click="deleteSingleUsageRule(index)"> 刪除設定</el-button>

                    <el-button class="is-round" type="primary" @click="saveSingleUsageRule(index)"> 儲存設定</el-button>
                  </div>
                </template>
              </el-form>
              <template v-if="!isCreated || (isCreated && index !== 0)">
                <el-collapse v-model="activeNames" class="custom-collapse isStyleLimit" style="border:0" accordion>
                  <el-form :ref="`form${index}`" class="el-form-item--white-bg" :validate-on-rule-change="true" :rules="formRules" :model="usageRule" label-position="top">
                    <el-collapse-item style="border:0" :name="`${index}`">
                      <div slot="title" class="el-collapse-title d-flex align-items-center"
                        >{{ usageRule.name }}
                        <span v-if="usageRule.rangeType === 'date'" class="d-lg-inline d-none" style="margin-left:35px">{{ usageRule.startDate }} ~ {{ usageRule.endDate }}</span>
                        <span v-if="usageRule.rangeType === 'week'" class="d-lg-inline d-none" style="margin-left:35px"
                          >星期 <span v-for="item in usageRule.range" :key="item">{{ daysInWeek[item] }} </span></span
                        >
                        <div class="ml-auto">
                          <el-switch v-model="usageRule.state" active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0" @click.stop.native></el-switch>
                        </div>
                      </div>
                      <!-- <div :class="$style.switch">
                        是否關閉限制
                        <el-form-item prop="state">
                          <el-switch v-model="usageRule.state" active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                      </div> -->
                      <el-form-item label="限制名稱" prop="name">
                        <el-input v-model="usageRule.name"> </el-input>
                      </el-form-item>
                      <el-form-item label="時段類別">
                        <el-select v-model="usageRule.rangeType">
                          <el-option label="日期" :value="`date`"></el-option>
                          <el-option label="星期" :value="`week`"></el-option>
                        </el-select>
                      </el-form-item>

                      <template v-if="usageRule.rangeType">
                        <el-form-item v-if="usageRule.rangeType === 'week'" prop="range" label="重複於">
                          <el-checkbox-group v-model="usageRule.range" :class="$style.repeat">
                            <el-checkbox-button v-for="(weekDay, i) in daysInWeek" :key="i" :label="String(i)">{{ weekDay }}</el-checkbox-button>
                          </el-checkbox-group>
                        </el-form-item>
                        <el-form-item v-if="usageRule.rangeType === 'date'" prop="startDate" label="日期">
                          <el-date-picker
                            v-model="filterDateRanges[index]"
                            type="daterange"
                            align="left"
                            unlink-panels
                            range-separator="-"
                            value-format="yyyy-MM-dd"
                            start-placeholder="起始日期"
                            end-placeholder="結束日期"
                            style="width: 100%"
                            :clearable="false"
                            @change="getStartAndEndDate($event, index)"
                          ></el-date-picker>
                        </el-form-item>
                        <span class="el-form-item__label">時間</span>
                        <el-form-item  v-for="(item, index2) in usageRule.timeRanges" :key="index2"   :prop="`timeRanges[${index2}][0]`"
                          :rules="{ required: true, message: '請輸入時間', trigger: 'blur' }"
                          style="margin-bottom: 30px">
                          <div class="inline-section">
                            <el-time-picker v-model="usageRule.timeRanges[index2]" 
                              :clearable="false" range-separator="至" format="HH:mm" value-format="HH:mm" placeholder="選擇時間" is-range

                            ></el-time-picker>
                            <el-button class="is-round is-no-border" :disabled="usageRule.timeRanges.length === 1" type="text" plain @click="deleteTimeRange(index, index2)">
                              <BaseIcon name="trash-alt" />
                            </el-button>
                          </div>
                        </el-form-item>
                        <el-button class="is-round is-fullwidth" style="margin-bottom: 40px" @click="addTimeRange(index)"><BaseIcon name="plus" /> 新增暫停使用時間</el-button>
                        <div class="btn-group-inline mt-4">
                          <el-button v-if="isCreated && index === 0 && defaultValue.usageRules" class="is-round" @click="cancelUsageRle"> 取消</el-button>
                          <el-button v-if="defaultValue.usageRules && !(isCreated && index === 0)" class="is-round" @click="deleteSingleUsageRule(index)"> 刪除設定</el-button>

                          <el-button v-if="isCreated" class="is-round" type="primary" @click="saveSingleUsageRule(index)"> 儲存設定</el-button>
                        </div>
                      </template>
                    </el-collapse-item>
                  </el-form>
                </el-collapse>
              </template>
            </div>
            <!-- <template v-else>
            <span>請新增限制，或選擇已有限制</span>
              
            
          </template> -->
          </div>
        </el-col>
      </el-row>
      <div v-else>
        請新增限制，或選擇已有限制
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.box {
  border: $color-border-base 1px solid;
  padding: 1px;
  border-radius: 6px;
  :global {
    .el-collapse-item__header {
      border: 0;
    }
    .el-collapse-item__wrap {
      border: 0;
    }
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-input__inner {
      border-color: $color-border-base;
      &:focus {
        border-color: $color-primary;
      }
    }
    .inline-section {
      display: flex;
      // margin-bottom: 15px;
    }
    .el-button.is-no-border {
      border: 0;
    }
  }
}
.switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;
  :global {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
.repeat {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @include max-md {
    justify-content: flex-start;
  }
  :global {
    .el-checkbox-button {
      margin-bottom: 1rem;
      .el-checkbox-button__inner {
        border-radius: 8px;
        padding: 14px 15px;
        border-color: #e5e7eb;
      }
      &.is-checked {
        .el-checkbox-button__inner {
          border-color: $color-primary;
          background: #fff;
          color: $color-primary;
        }
      }
      & + .el-checkbox-button {
        margin-left: 5px;
        .el-checkbox-button__inner {
          border-left: 1px solid #e5e7eb;
        }
      }
    }
  }
}
</style>
